import { getRequest, postRequest } from "../../../services/RestServices";
import * as urls from "../../api/scheduler/url";
export const getMaterialData = async (payload) => {
  try {
    return await postRequest(urls.GET_MATERIAL_DATA, payload);
  } catch (err) {
    return err;
  }
};
